import axios, { AxiosResponse } from "axios";
import moment from "moment";
import { IStatisticalParams } from "../models/statisticalChartModels";
import { localStorageItem } from "../../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";

const API_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL;

export const getAllDataStatistical = (): Promise<AxiosResponse<any>> => {
  let currentYear = moment().year();
  let url = `${API_URL}/thong-ke?nam=${currentYear}`;
  return axios.get(url);
};

export const getItemDataStatistical = ({type, year}: IStatisticalParams): Promise<AxiosResponse<any>> => {
  let url = `${API_URL}/thong-ke/get-by-type?type=${type}&nam=${year}`;
  return axios.get(url);
};